import { useGetJobDetailQuery, useGetJobListQuery } from '@/api/sanity/generated';
import { sanityLanguage } from '@/constants/language';
import { JobDetail } from '@/types/job';
import { serialize } from 'next-mdx-remote/serialize';

export async function getJobDetail(slug: string): Promise<JobDetail | null> {
	const fetchJobDetail = useGetJobDetailQuery.fetcher({
		slug,
		i18nLang: sanityLanguage,
	});

	const jobDetail = await fetchJobDetail();

	if (!jobDetail.allJobs?.[0]) {
		return null;
	}

	if (!jobDetail.allJobs[0].slug?.current) {
		return null;
	}

	const serializedJobDetail: JobDetail = {
		...jobDetail.allJobs[0],
		descriptionMarkdown: jobDetail.allJobs[0].description
			? await serialize(jobDetail.allJobs[0].description, { parseFrontmatter: true })
			: undefined,
		name: jobDetail.allJobs[0].name || '',
		slug: { current: jobDetail.allJobs[0].slug.current || '' },
	};

	return serializedJobDetail;
}

export async function getJobDetailStaticPaths() {
	const fetchAllJobs = useGetJobListQuery.fetcher({
		i18nLang: sanityLanguage,
	});
	const jobs = await fetchAllJobs();

	const paths = jobs.allJobs?.map((job) => ({
		params: { job: job?.slug?.current || '' },
	}));

	return {
		paths: paths?.filter(Boolean) || [],
		fallback: false,
	};
}
